import type { Directive } from 'vue';
declare const vDis: Directive<HTMLElement, boolean>;
export default vDis;
